module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    staticClass: "list-item",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function($event) {
        _vm.listTileClicked(_vm.product())
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "list-item__title",
    class: {
      'inCart': _vm.collected
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product().name) + "\n      ")])])], 1), _vm._v(" "), (_vm.shoppingState && _vm.type === 'list') ? _c('v-list-tile-action', [(_vm.collected) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("check_box")]) : _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("check_box_outline_blank")])], 1) : _vm._e(), _vm._v(" "), (!_vm.shoppingState && _vm.type === 'list') ? _c('v-list-tile-action', {
    staticClass: "draggable"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("drag_indicator")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'category') ? _c('v-list-tile-action', [(_vm.onList && !_vm.$store.getters.getEditMode) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("check")]) : _vm._e(), _vm._v(" "), (!_vm.onList && !_vm.$store.getters.getEditMode) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getEditMode) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("close")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34910254","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ListItem.vue
// module id = 484
// module chunks = 1